<app-layout-main [pageMetadata]="{ title: originalAppName() }" [layoutSize]="'small'" [design]="'clean'">
	<lib-card [title]="'Privacy policy'">
		<div>
			<p>
				This is the Privacy Policy for Gymvio, accessible from
				<a href="https://gymvio.com">https://gymvio.com</a> and all subdomains
			</p>

			<p>
				This privacy policy will explain how we use the personal data we collect from you when you use our
				website.
			</p>

			<h4 class="mt-3">Gymvio collects the following data:</h4>
			<p>
				Personal identification information (Name, email address, phone number, city, address, body composition
				details such as weight, height etc.). Trainers of the application can also write notes about their
				clients such as their health condition, goals or other information. All data is the result of direct
				input by users on the website. We do not get this data from anywhere else. This information is also not
				shared with any 3rd party.
			</p>

			<h4 class="mt-3">How do we collect your data?</h4>
			<p>
				You or your trainer directly provide us most of the data we collect. We collect data and process data
				when you:
			</p>
			<ul>
				<li>Register online or place an order for any of our products or services.</li>
				<li>You configure your profile using the online forms after logging into the application.</li>
				<li>Or your trainer sets up your (client) profile and fills in data about you directly.</li>
				<li>
					Or your trainer manages your profile on continuous basic (e.g. tracking progress of your efforts).
				</li>
				<li>
					Voluntarily complete a customer survey or provide feedback on any of our message boards or via
					email.
				</li>
			</ul>

			<p class="mt-2">Gymvio may also receive your data indirectly from the following sources:</p>
			<ul>
				<li>
					Paddle.com - payments are processed by paddle.com and we may see some information about you after
					successfully buy subscription. This information might include your location or e-mail you provided.
					There could be additional information provided by paddle.com.
				</li>
			</ul>

			<h4 class="mt-3">How will we use your data?</h4>
			<p class="mt-2">Gymvio collects your data so that we can:</p>
			<ul class="mt-2">
				<li>Process your order and manage your account.</li>
				<li>
					Send you notifications to fulfill application purpose to inform you about appointments, workout
					plans and other features we offer.
				</li>
				<li>Email you with special offers on other products and services we think you might like.</li>
			</ul>

			<h4 class="mt-3">How do we store your data?</h4>
			<p class="mt-2">
				Gymvio securely stores your data at Microsoft's Azure Database with encryption. Additionally, all
				traffic between you and server is secured with <strong>SSL (https)</strong> which you can see in the
				browser bar next to the website URL address.
			</p>

			<h4 class="mt-3">Marketing</h4>

			<p class="mt-2">
				Gymvio would like to send you information about products and services of ours that we think you might
				like, as well as those of our partner companies. If you have agreed to receive marketing, you may always
				opt out at a later date.
			</p>

			<p class="mt-2">
				You have the right at any time to stop Gymvio from contacting you for marketing purposes or giving your
				data to other members of the Gymvio Group.
			</p>

			<p class="mt-2">
				If you no longer wish to be contacted for marketing purposes, please send us an e-mail at
				info[at]gymvio.com.
			</p>

			<h4 class="mt-3">What are your data protection rights?</h4>

			<p class="mt-2">
				Gymvio would like to make sure you are fully aware of all of your data protection rights. Every user is
				entitled to the following:
			</p>
			<ul>
				<li>
					The right to access – You have the right to request Gymvio for copies of your personal data. We may
					charge you a small fee for this service.
				</li>
				<li>
					The right to rectification – You have the right to request that Gymvio correct any information you
					believe is inaccurate. You also have the right to request Gymvio to complete the information you
					believe is incomplete.
				</li>
				<li>
					The right to erasure – You have the right to request that Gymvio erase your personal data, under
					certain conditions.
				</li>
				<li>
					The right to restrict processing – You have the right to request that Gymvio restrict the processing
					of your personal data, under certain conditions.
				</li>
				<li>
					The right to object to processing – You have the right to object to Gymvio's processing of your
					personal data, under certain conditions.
				</li>
				<li>
					The right to data portability – You have the right to request that Gymvio transfer the data that we
					have collected to another organization, or directly to you, under certain conditions.
				</li>
				<li>
					If you make a request, we have one month to respond to you. If you would like to exercise any of
					these rights, please contact us at our email: info[at]gymvio.com
				</li>
			</ul>

			<h4 class="mt-3">How to contact us</h4>

			<p class="mt-2">
				If you have any questions about Gymvio's privacy policy, the data we hold on you, or you would like to
				exercise one of your data protection rights, please do not hesitate to contact us on following e-mail:
				info[at]gymvio.com
			</p>

			<h4 class="mt-3">How to contact the appropriate authority</h4>

			<p class="mt-2">
				Should you wish to report a complaint or if you feel that Gymvio has not addressed your concern in a
				satisfactory manner, you may contact the Information Commissioner's Office.
			</p>
		</div>
	</lib-card>
</app-layout-main>
